import { ApiProperty } from "@nestjs/swagger";

export class SubJobSoRequest{
    @ApiProperty()
    soId:number;
}